import { createStore } from 'vuex';
import auth from './modules/auth.js'
import register from './modules/register.js';
import logout from './modules/logout.js';
import cart from './modules/cart.js';
import wishlist from './modules/wishlist.js';

const store = createStore({
    modules: {
        auth,
        register,
        logout,
        cart,
        wishlist
    },

    state: {
        isLoggedIn: false,
        userData: null,
        products: [],
        isLoading: false
    },

    mutations: {
        setIsLoggedIn(state, status) {
            state.isLoggedIn = status;
        },

        setUser(state, status) {           
            console.log("Setting user data: ", status);
            state.userData = status;
        },

        logout(state) {
            state.isLoggedIn = false;
        },

        setProducts(state, products) {
            state.products = products;
        },

        setLoading(state, status) {
            state.isLoading = status;
        },
    },

    actions: {
        async checkLoggedIn(context) {
            const userData = JSON.parse(localStorage.getItem('user'));
            if (userData) {
                context.commit('setIsLoggedIn', true);
                context.commit('setUser', userData)
            } else {
                context.commit('setIsLoggedIn', false);
            }
        },

        async fetchProducts(context) {
            if(context.state.products.length > 0) {
                context.commit('setLoading', false)
                return;
            }

            context.commit("setLoading", true);

            try {
                console.log('API URL:', process.env.VUE_APP_URL);
                const response = await fetch(`${process.env.VUE_APP_URL}/products`);
                if(!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }

                const data = await response.json();
                context.commit('setProducts', data);

            } catch(error) {
                console.error(error);
            } finally {
                context.commit('setLoading', false)
            }
        },
    },

    getters: {
        isLoggedIn(state) {
            return state.isLoggedIn;
        },

        userData(state) {
            return state.userData;
        },

        getProductByCategory(state) {
            return function(category) {
                return state.products.filter(product => product.category === category);
            };
        },

        getAllProducts(state) {
            return state.products;
        },

        isLoading(state) {
            return state.isLoading;
        },
    },

});

store.dispatch('checkLoggedIn'); // Вызываем проверку сразу при инициализации

export default store;



